<script setup>
import { onMounted, ref } from "vue";
import Buttons from "./Buttons.vue";
import {
  Button,
  Field,
  FieldStatusMessage,
  Input,
  Label,
  Textarea,
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
  toast,
} from "@starline-security/component-library";

const themes = [
  "https://m-kiruba.github.io/testing/theme1.css",
  "https://m-kiruba.github.io/testing/theme2.css",
  "https://m-kiruba.github.io/testing/theme3.css",
];

const currentTheme = ref(themes[0]);

onMounted(() => {
  // add css variables
  // document.documentElement.style.setProperty("--bg-btn", "#51b592");
  // document.documentElement.style.setProperty("--color-secondary", "#0e3753");

  // document.documentElement.style.setProperty("--color-button-primary", "#0e3753");
  // document.documentElement.style.setProperty("--button-primary-color", "#0e3753");

  // const link = document.createElement('link');
  // link.rel = 'stylesheet';
  // link.href = currentTheme.value;
  // link.onload = () => console.log('Theme CSS loaded!');
  // link.onerror = () => console.error('Failed to load theme CSS.');

  // document.head.appendChild(link);

  console.log("mounted");
});
</script>

<template>
  <!-- style to make the landing page look good to showcase the components, use tailwind with tw: prefix-->
  <div class="tw:p-4 tw:bg-slate-300">
    <h1 class="tw:text-2xl">Playground</h1>
    <Buttons />

    <h2>Toast</h2>
    <div class="tw:flex tw:flex-col tw:items-start tw:gap-2">
      <Button
        @click="
          () => {
            toast('Generic Toast', {
              action: {
                label: 'Undo',
                onClick: () => console.log('Undo'),
              },
            });
          }
        "
      >
        Generic toast
      </Button>

      <Button
        @click="
          () => {
            toast.success(
              'This is a success messge This is a success messge This is a success messge This is a success messge',
              {
                action: { label: 'DDD', onClick: () => console.log('Clicked') },
              }
            );
          }
        "
      >
        Show Success Toast
      </Button>

      <Button
        @click="
          () => {
            toast.error('Error Toast', {
              action: { label: 'DDD', onClick: () => console.log('Clicked') },
            });
          }
        "
      >
        Error Toast
      </Button>

      <Button
        @click="
          () => {
            toast.info('Info Toast', {
              action: { label: 'DDD', onClick: () => console.log('Clicked') },
            });
          }
        "
      >
        Info Toast
      </Button>

      <Button
        @click="
          () => {
            toast.warning('Warning Toast', {
              action: { label: 'DDD', onClick: () => console.log('Clicked') },
            });
          }
        "
      >
        Warning Toast
      </Button>
    </div>

    <h2>Tabs</h2>

    <h2>Tabs</h2>

    <Tabs default-value="account" class="w-[400px]">
      <TabsList>
        <TabsTrigger value="account"> Account </TabsTrigger>
        <TabsTrigger value="password"> Password </TabsTrigger>
      </TabsList>
      <TabsContent value="account">
        Make changes to your account here.
      </TabsContent>
      <TabsContent value="password"> Change your password here. </TabsContent>
    </Tabs>

    <h2>Field compoennt/ Text</h2>

    <div
      class="tw:bg-white tw:p-4 tw:grid tw:grid-cols-4 tw:gap-2 tw:flex-wrap"
    >
      <h2>DropdownMenu</h2>

      <DropdownMenu>
        <DropdownMenuTrigger as-child>
          <Button variant="secondary">Open</Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownMenuLabel>My Account</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem>Profile</DropdownMenuItem>
          <DropdownMenuItem>Billing</DropdownMenuItem>
          <DropdownMenuItem>Team</DropdownMenuItem>
          <DropdownMenuItem>Subscription</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <Input type="text" placeholder="Default Input" />
      <Input type="text" placeholder="Rounded Input" rounded="default" />
      <Input
        type="text"
        placeholder="Rounded Full Input"
        rounded="full"
        class="tw:rounded-full"
      />
      <Input type="text" placeholder="Square" rounded="none" />
      <Input type="text" placeholder="Large" size="lg" />
      <Input type="text" placeholder="Small" size="sm" />
      <Input type="text" placeholder="Md" size="md" />
      <Input type="text" placeholder="With Error" status="error" />

      <Field>
        <Label>With Label</Label>
        <Input type="text" placeholder="Enter your name." />
      </Field>

      <Field :disabled="true">
        <Label>With Label Disabled</Label>
        <Input type="text" placeholder="Enter your name." />
      </Field>

      <Field status="error">
        <Label>With Label Error</Label>
        <Input type="text" placeholder="Enter your name." />
      </Field>

      <Field status="error" status-text="The error message">
        <Label>With Label and Error Message</Label>
        <Input type="text" placeholder="Enter your name." />
        <FieldStatusMessage class="tw:mt-0" />
      </Field>

      <Field status="error" status-text="The error message">
        <Label>Textarea</Label>
        <Textarea placeholder="Enter your message." />
        <FieldStatusMessage />
      </Field>
    </div>
  </div>
</template>
